import React, { useState } from "react";
import { Loader2, Bell, Mail, User } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { ROLE_LABELS } from "../lib/format";
import { PageHeader } from "../components/common";
import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

export default function Settings() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({
    name: user?.name || "",
    phone: user?.phone || "",
    notify_email: user?.notify_email ?? true,
    notify_app: user?.notify_app ?? true,
  });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/settings", form);
      setUser(data);
      toast.success("Parametres enregistres");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div>
      <PageHeader title="Parametres" subtitle="Profil et preferences de notification." />
      <div className="grid gap-8 lg:grid-cols-2 max-w-4xl">
        <Card className="p-6">
          <h3 className="font-display text-lg font-semibold text-slate-900 mb-1 flex items-center gap-2"><User className="h-5 w-5 text-teal-500" /> Profil</h3>
          <p className="text-sm text-slate-500 mb-5">{ROLE_LABELS[user?.role]} · {user?.email}</p>
          <div className="space-y-4">
            <div><Label>Nom complet</Label><Input data-testid="settings-name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="mt-1.5" /></div>
            <div><Label>Telephone</Label><Input data-testid="settings-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className="mt-1.5" /></div>
          </div>
        </Card>

        <Card className="p-6">
          <h3 className="font-display text-lg font-semibold text-slate-900 mb-5 flex items-center gap-2"><Bell className="h-5 w-5 text-teal-500" /> Notifications</h3>
          <div className="space-y-4">
            <div className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-3">
              <div className="flex items-center gap-3"><Bell className="h-4 w-4 text-slate-400" /><div><p className="text-sm font-medium text-slate-800">Notifications dans l'app</p><p className="text-xs text-slate-400">Alertes de validation et d'echeance</p></div></div>
              <Switch data-testid="toggle-app" checked={form.notify_app} onCheckedChange={(v) => setForm({ ...form, notify_app: v })} />
            </div>
            <div className="flex items-center justify-between rounded-lg border border-slate-100 px-4 py-3">
              <div className="flex items-center gap-3"><Mail className="h-4 w-4 text-slate-400" /><div><p className="text-sm font-medium text-slate-800">Rappels par email</p><p className="text-xs text-slate-400">Rappels automatiques des echeances</p></div></div>
              <Switch data-testid="toggle-email" checked={form.notify_email} onCheckedChange={(v) => setForm({ ...form, notify_email: v })} />
            </div>
          </div>
        </Card>
      </div>
      <div className="mt-6">
        <Button data-testid="settings-save" onClick={save} disabled={saving} className="bg-teal-600 hover:bg-teal-700">
          {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Enregistrer"}
        </Button>
      </div>
    </div>
  );
}
